import React, { Component } from 'react'
import { Input, InputNumber, Tooltip, Button, Popconfirm, Form, Select, Spin } from 'antd'
import numeral from 'numeral'
import { arrayMove, removeCurrencyMarkup, sanitizeItem, handleItemCalcs } from '../../util'
import EstimateSection from '../estimate/EstimateSection'
import styled from 'styled-components'
import history from '../../history'
import _ from 'lodash'
import config from '../../config'

const { API_BASE } = config

const { TextArea } = Input
const Option = Select.Option

const FormItem = Form.Item
const MarginTop = styled.div`
  margin-top: 15px;
`
class EstimateTemplateForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chargedTemplate: false,
      dataStructure: []
    }
  }

  componentDidMount() {
    this.setState({
      dataStructure: this.props.dataStructure
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const form = this.props.form
    if (this.props.currentId !== prevProps.currentId) {
      if (this.props.currentId === 0) {
        form.resetFields()
        this.setState({
          dataStructure: []
        })
      }
      if (this.props.currentId > 0) {
        const { templateInfo } = this.props

        form.setFieldsValue({
          overhead: templateInfo.overhead,
          markup: templateInfo.markup,
          tax: templateInfo.tax,
          description: templateInfo.description
        })
      }
    }

    // do the form math on the first charge
    if (this.state.dataStructure !== prevState.dataStructure) {
      this.doFormMath()
    }

    if (prevProps.dataStructure !== this.props.dataStructure) {
      this.setState({
        dataStructure: this.props.dataStructure
      })
    }
  }

  handleItemChange = (itemId, itemIndex, sectionIndex) => {
    const { dataStructure } = this.state
    const { templateInfo, items } = this.props

    let newDataStructure = dataStructure

    let item = items.find(item => {
      return item.id === itemId
    })

    const form = this.props.form

    // sanitize the item to compose the list
    item.item_id = item.id
    item.tax = templateInfo ? templateInfo.tax : form.getFieldValue('tax') / 100
    item.overhead = templateInfo ? templateInfo.overhead : form.getFieldValue('overhead') / 100
    item.markup = templateInfo ? templateInfo.markup : form.getFieldValue('markup') / 100

    newDataStructure[sectionIndex].items[itemIndex] = item

    this.setState(
      {
        dataStructure: newDataStructure
      },
      () => {
        this.doFormMath()
      }
    )
  }

  handleSectionDown = sectionIndex => {
    const sortedDataStructure = arrayMove(this.state.dataStructure, sectionIndex, sectionIndex + 1)

    this.setState({
      dataStructure: sortedDataStructure
    })
  }

  handleSectionUp = sectionIndex => {
    const sortedDataStructure = arrayMove(this.state.dataStructure, sectionIndex, sectionIndex - 1)

    this.setState({
      dataStructure: sortedDataStructure
    })
  }

  handleItemDown = (itemIndex, sectionIndex) => {
    const { dataStructure } = this.state

    const sortedItemDataStructure = arrayMove(
      this.state.dataStructure[sectionIndex].items,
      itemIndex,
      itemIndex + 1
    )

    dataStructure[sectionIndex].items = sortedItemDataStructure

    this.setState({
      dataStructure
    })
  }

  handleItemUp = (itemIndex, sectionIndex) => {
    const { dataStructure } = this.state

    const sortedItemDataStructure = arrayMove(
      this.state.dataStructure[sectionIndex].items,
      itemIndex,
      itemIndex - 1
    )

    dataStructure[sectionIndex].items = sortedItemDataStructure

    this.setState({
      dataStructure
    })
  }

  handleAddSection = () => {
    let { dataStructure } = this.state

    if (dataStructure) {
      dataStructure.push({
        name: 'Unnamed Section'
      })
    } else {
      dataStructure = [
        {
          name: 'Unnamed Section'
        }
      ]
    }

    this.setState({
      dataStructure,
      chargedTemplate: true
    })
  }

  handleAddItem = sectionIndex => {
    const { dataStructure } = this.state
    const { templateInfo } = this.props

    const form = this.props.form

    const item = {
      tax: templateInfo ? templateInfo.tax : form.getFieldValue('tax') / 100,
      overhead: templateInfo ? templateInfo.overhead : form.getFieldValue('overhead') / 100,
      markup: templateInfo ? templateInfo.markup : form.getFieldValue('markup') / 100
    }

    if (dataStructure[sectionIndex].items) {
      dataStructure[sectionIndex].items.push(item)
    } else {
      dataStructure[sectionIndex].items = [item]
    }

    this.setState({
      dataStructure
    })
  }

  handleItemColumnChange = (e, field, itemIndex, sectionIndex) => {
    const { dataStructure } = this.state
    let inputValue = null
    switch (field) {
      case 'description':
        inputValue = e.target.value
        break
      case 'cost':
        inputValue = e.replace('$', '')
        break
      default:
        inputValue = e
        break
    }

    const item = dataStructure[sectionIndex].items[itemIndex]
    const newItem = { ...item, [field]: inputValue }
    dataStructure[sectionIndex].items[itemIndex] = newItem

    this.setState(
      {
        dataStructure
      },
      () => {
        this.doFormMath()
      }
    )
  }

  handleSectionDelete = sectionIndex => {
    if (window.confirm('Are you sure you want to delete this SECTION?')) {
      let { dataStructure } = this.state

      dataStructure.splice(sectionIndex, 1)

      this.setState(
        {
          dataStructure
        },
        () => {
          this.doFormMath()
        }
      )
    }
  }

  handleItemDelete = (sectionIndex, itemIndex) => {
    if (window.confirm('Are you sure you want to delete this ITEM?')) {
      let { dataStructure } = this.state

      dataStructure[sectionIndex].items.splice(itemIndex, 1)

      this.setState(
        {
          dataStructure
        },
        () => {
          this.doFormMath()
        }
      )
    }
  }

  handleSectionNameChange = (e, sectionIndex) => {
    let { dataStructure } = this.state

    dataStructure[sectionIndex].name = e.target.value

    this.setState({
      dataStructure
    })
  }

  handleGeneralOverheadChange = value => {
    const { dataStructure } = this.state
    dataStructure.forEach((section, sectionindex) => {
      section.items.forEach((item, itemIndex) => {
        dataStructure[sectionindex].items[itemIndex].overhead = value / 100
      })
    })

    this.setState(
      {
        dataStructure
      },
      () => {
        this.doFormMath()
      }
    )
  }

  handleGeneralMarkupChange = value => {
    const { dataStructure } = this.state
    dataStructure.forEach((section, sectionindex) => {
      section.items.forEach((item, itemIndex) => {
        dataStructure[sectionindex].items[itemIndex].markup = value / 100
      })
    })

    this.setState(
      {
        dataStructure
      },
      () => {
        this.doFormMath()
      }
    )
  }

  handleGeneralTaxChange = value => {
    const { dataStructure } = this.state
    dataStructure.forEach((section, sectionindex) => {
      section.items.forEach((item, itemIndex) => {
        dataStructure[sectionindex].items[itemIndex].tax = value / 100
      })
    })

    this.setState(
      {
        dataStructure
      },
      () => {
        this.doFormMath()
      }
    )
  }

  handleSelectedTemplate = templateId => {
    const selectedTemplate = this.state.templateOptions.find(
      template => template.value === templateId
    )
    return selectedTemplate ? selectedTemplate.text : null
  }

  doFormMath = () => {
    // calculate the sections/items
    const { dataStructure } = this.state

    dataStructure.forEach((section, sectionIndex) => {
      if (section.items && section.items.length > 0) {
        section.items.forEach((item, itemIndex) => {
          const itemSanitized = sanitizeItem(item)
          dataStructure[sectionIndex].items[itemIndex] = handleItemCalcs(itemSanitized)
        })
      }
    })

    this.setState(
      {
        dataStructure
      },
      () => {
        // calculate the totals
        let total = 0.0
        let overhead_total = 0.0
        let markup_total = 0.0
        let tax_total = 0.0
        let grand_total = 0.0
        if (this.state.dataStructure) {
          this.state.dataStructure.forEach(section => {
            if (section.items && section.items.length > 0) {
              section.items.forEach(item => {
                total += +removeCurrencyMarkup(item.cost) * item.quantity
                overhead_total += +removeCurrencyMarkup(item.overhead_total)
                markup_total += +removeCurrencyMarkup(item.markup_total)
                tax_total += +removeCurrencyMarkup(item.tax_total)
                grand_total += +removeCurrencyMarkup(+item.grand_total)
              })
            }
          })
          this.setState({
            totals: {
              total,
              overhead_total,
              markup_total,
              tax_total,
              grand_total
            }
          })
        }
      }
    )
  }
  handleCreate = () => {
    const { onCreate } = this.props

    if (onCreate) {
      const form = this.props.form
      form.validateFields((err, values) => {
        if (err) {
          return
        }
        const estimate = {
          estimateSections: this.state.dataStructure,
          estimateData: values,
          estimateTotals: this.state.totals
        }
        onCreate(estimate)
      })
    }
  }

  handleRevisionChange = value => {
    const { form } = this.props

    const revisions = JSON.parse(this.props.revisions.find(x => x.id === value).json_patch)

    let changes = {}
    revisions.forEach(revision => {
      const fieldName = revision.path.substring(1, revision.path.length)
      if (fieldName === 'estimateSections') {
        const sectionsWithItems = JSON.parse(revision.value)
        this.setState({
          dataStructure: sectionsWithItems
        })
      }
      if (!_.isNil(form.getFieldsValue()[fieldName])) {
        let value = revision.value ? revision.value.toString() : ''
        if (fieldName === 'tax' || fieldName === 'markup' || fieldName === 'overhead') {
          value = value * 100
        }
        changes[fieldName] = value
      }
    })

    form.setFieldsValue(changes)
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { items, templateInfo, revisions, loadingRevision } = this.props

    return (
      <div>
        <h2>Estimate Template</h2>
        {templateInfo && (
          <div className="row">
            <div className="col-md-3">
              <a
                target="_blank"
                href={`${API_BASE}/api/templates/estimate/${templateInfo.id}/print`}
              >
                <Button icon="printer">Print template</Button>
              </a>
            </div>
          </div>
        )}
        <Form>
          <div className="row">
            <div className="col-6">
              <FormItem label="Template">
                {getFieldDecorator('name', {
                  initialValue: templateInfo ? templateInfo.name : null
                })(<Input />)}
              </FormItem>
            </div>
            <div className="col-6">
              <div className="row">
                <div className="col-4">
                  <Tooltip
                    placement="topLeft"
                    title="Changing this value will affect the overhead value in ALL items in this Estimate."
                  >
                    <FormItem label="Overhead">
                      {getFieldDecorator('overhead', {
                        initialValue:
                          templateInfo && templateInfo.overhead !== 0
                            ? templateInfo.overhead * 100
                            : null,
                        onChange: this.handleGeneralOverheadChange
                      })(
                        <InputNumber
                          min={0}
                          formatter={value => `${value}%`}
                          parser={value => value.replace('%', '')}
                        />
                      )}
                    </FormItem>
                  </Tooltip>
                </div>
                <div className="col-4">
                  <Tooltip
                    placement="topLeft"
                    title="Changing this value will affect the markup value in ALL items in this Estimate."
                  >
                    <FormItem label="Markup">
                      {getFieldDecorator('markup', {
                        initialValue:
                          templateInfo && templateInfo.markup !== 0
                            ? templateInfo.markup * 100
                            : null,
                        onChange: this.handleGeneralMarkupChange
                      })(
                        <InputNumber
                          min={0}
                          formatter={value => `${value}%`}
                          parser={value => value.replace('%', '')}
                        />
                      )}
                    </FormItem>
                  </Tooltip>
                </div>
                <div className="col-4">
                  <Tooltip
                    placement="topLeft"
                    title="Changing this value will affect the tax value in ALL items in this Estimate."
                  >
                    <FormItem label="Tax">
                      {getFieldDecorator('tax', {
                        initialValue:
                          templateInfo && templateInfo.tax !== 0 ? templateInfo.tax * 100 : null,
                        onChange: this.handleGeneralTaxChange
                      })(
                        <InputNumber
                          min={0}
                          max={100}
                          formatter={value => `${value}%`}
                          parser={value => value.replace('%', '')}
                        />
                      )}
                    </FormItem>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
          {templateInfo && (
            <div className="row">
              <div className="col-3">
                <FormItem label="Revision">
                  {loadingRevision ? (
                    <Spin size="small" />
                  ) : (
                    <Select
                      defaultValue={
                        revisions && revisions.length > 0
                          ? revisions[revisions.length - 1].id
                          : null
                      }
                      onChange={this.handleRevisionChange}
                    >
                      {revisions &&
                        revisions.map(revision => (
                          <Option key={revision.id} value={revision.id}>
                            {revision.revision}
                          </Option>
                        ))}
                    </Select>
                  )}
                </FormItem>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-12">
              <FormItem label="Description">
                {getFieldDecorator('description', {
                  initialValue: templateInfo ? templateInfo.description : null
                })(<TextArea placeholder="Type in description..." rows={4} />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <Button onClick={() => this.handleAddSection()}> Add Section</Button>

              <Popconfirm
                title="Are you sure you want to delete this record?"
                onConfirm={this.props.handleDelete}
                okText="Yes"
                cancelText="No"
              >
                {this.props.templateInfo && (
                  <Button type="danger" icon="delete" className="marginLeft5" />
                )}
              </Popconfirm>
            </div>
            <div className="col-md-5 text-right">
              <h6>Total:</h6>
              <h6>Overhead:</h6>
              <h6>Markup:</h6>
              <h6>Tax:</h6>
              <h5>Grand Total:</h5>
            </div>
            <div className="col-md-2">
              <h6>
                <b>{numeral(this.state.totals && this.state.totals.total).format('$0,0.00')}</b>
              </h6>
              <h6>
                <b>
                  {numeral(this.state.totals && this.state.totals.overhead_total).format('$0,0.00')}
                </b>
              </h6>
              <h6>
                <b>
                  {numeral(this.state.totals && this.state.totals.markup_total).format('$0,0.00')}
                </b>
              </h6>
              <h6>
                <b>{numeral(this.state.totals && this.state.totals.tax_total).format('$0,0.00')}</b>
              </h6>
              <h5>
                <b>
                  {numeral(this.state.totals && this.state.totals.grand_total).format('$0,0.00')}
                </b>
              </h5>
            </div>
          </div>
        </Form>
        <div className="row">
          <div className="col-12">
            {this.state.dataStructure &&
              this.state.dataStructure.length > 0 && (
                <div className="row">
                  <div className="col-12">
                    {this.state.dataStructure.map((section, index) => (
                      <EstimateSection
                        key={index}
                        section={section}
                        sectionIndex={index}
                        items={items}
                        handleItemChange={this.handleItemChange}
                        handleSectionDown={this.handleSectionDown}
                        handleSectionUp={this.handleSectionUp}
                        handleSectionDelete={this.handleSectionDelete}
                        handleItemUp={this.handleItemUp}
                        handleItemDown={this.handleItemDown}
                        handleAddItem={this.handleAddItem}
                        handleItemDelete={this.handleItemDelete}
                        handleItemColumnChange={this.handleItemColumnChange}
                        handleSectionNameChange={this.handleSectionNameChange}
                      />
                    ))}
                  </div>
                </div>
              )}
          </div>
        </div>

        <MarginTop>
          <Button onClick={() => history.goBack()}>Cancel</Button>{' '}
          <Button type="primary" onClick={() => this.handleCreate()}>
            {this.props.currentId === 0 && <span>Create Template</span>}
            {this.props.currentId > 0 && <span>Save Changes</span>}
          </Button>
        </MarginTop>
      </div>
    )
  }
}

export default Form.create()(EstimateTemplateForm)



// WEBPACK FOOTER //
// ./src/components/templates/EstimateTemplateForm.js